import PaginationModel from "@/models/paginationModel";

import EstoqueModel from "../models/estoqueModel";
import nfetch from "../utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";

function mapCombo(dados: EstoqueModel[]) {
    return dados.map(p => ({
        value: p.id!,
        text: p.descricao,
        franquiaId: p.franquiaId,
    }));
}

class EstoqueByFranquiaService extends iServiceCached<EstoqueModel> {
    constructor() {
        super("Estoque");
    }

    public async comboCached(franquiaId: number) {
        return await this.comboCachedByFranquiaId(franquiaId);
    }

    public async comboCachedByFranquiaId(franquiaId: number) {
        if (this.cached[franquiaId]) {
            return mapCombo(this.cached[franquiaId]);
        }

        const response = await nfetch(`/${this.controllerName}/ListEstoqueSaida?franquiaId=${franquiaId}`, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<PaginationModel<EstoqueModel>>();

        this.cached[franquiaId] = response.list.sort((a, b) => a.descricao.localeCompare(b.descricao));
        return mapCombo(response.list);
    }

    public listByFranquiaId(franquiaId?: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/ListByFranquiaId?franquiaId=${franquiaId}`, {
            credentials: "same-origin",
        });
    }
}

export default new EstoqueByFranquiaService();
